import { render } from "./ImportLocaleFile.vue?vue&type=template&id=3c763c86"
import script from "./ImportLocaleFile.vue?vue&type=script&lang=js"
export * from "./ImportLocaleFile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__